<template>
  <section class="review-awards eu" :class="{ desktop: $isDesktop }">
    <div class="hero eu">
      <div>
        <h1>
          <translate>Pitchup.com review awards</translate>
          <br v-if="$isDesktop" /><translate>France</translate> 2024
        </h1>
        <review-awards-pages-nav />
      </div>
    </div>

    <review-awards-intro />

    <section id="golds" class="top-5">
      <div class="golds-heading">
        <img
          loading="lazy"
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="36"
          height="32"
        />
        <translate tag="h2" :tt="{ numberOfSites: 20 }">
          Top {numberOfSites} campsites in France
        </translate>
      </div>
      <div class="top-5-data">
        <review-awards-top-sites :data="TopSitesFRData" />
      </div>
    </section>
    <nuxt-to-meta :nuxt2meta="head" />
  </section>
</template>
<script setup lang="ts">
import SCHEMA_ORGANIZATION from '../../../../json/schemaOrganization.json'
import { computed } from 'vue'

definePageMeta({
  layout: 'default',
})

const TopSitesFRData = [
  {
    id: '1',
    name: 'Camping Sous Les Etoiles Normandie',
    region: 'Lower Normandy',
    url: '/campsites/france/basse-normandie/calvados/saint_martin_des_besaces/camping_sous_les_etoiles_normandie/',
    rating: 9.9,
    reviewsCount: 68,
    pitchTypes: [
      {
        pitchTypesCount: 10,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 30,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '2',
    name: 'Le Marais Sauvage',
    region: 'Pays de la Loire',
    url: '/campsites/france/pays-de-la-loire/vendee/le-mazeau/camp-vert/',
    rating: 9.9,
    reviewsCount: 28,
    pitchTypes: [
      {
        pitchTypesCount: 10,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 10,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 10,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '3',
    name: 'Camping La Foret de Tesse',
    region: 'Poitou-Charentes',
    url: '/campsites/france/poitou-charentes/charente/la_foret_de_tesse/camping_la_foret_de_tesse/',
    rating: 9.9,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 11,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 11,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 11,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '4',
    name: 'La Ferme des 4 Chenes',
    region: 'Aquitaine',
    url: '/campsites/france/aquitaine/pyrenees-atlantiques/urt/la_ferme_des_4_chenes/',
    rating: 9.9,
    reviewsCount: 22,
    pitchTypes: [
      {
        pitchTypesCount: 105,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 105,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 105,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 25,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
      {
        pitchTypesCount: 4,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '5',
    name: 'Camping Le Clos Castel',
    region: 'Basse-Normandie',
    url: '/campsites/france/basse-normandie/manche/raids/camping-le-clos-castel/',
    rating: 9.8,
    reviewsCount: 37,
    pitchTypes: [
      {
        pitchTypesCount: 4,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 6,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 6,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '6',
    name: "Camping Les Portes de L'Anjou",
    region: 'Pays de la Loire',
    url: '/campsites/france/pays-de-la-loire/maine-et-loire/durtal/camping_les_portes_de_lanjou/',
    rating: 9.8,
    reviewsCount: 34,
    pitchTypes: [
      {
        pitchTypesCount: 81,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 81,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 81,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 3,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 16,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
      {
        pitchTypesCount: 2,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '7',
    name: 'Les Pieds sur Terre, le Nez dans les Haies, la Tete dans les Etoiles',
    region: 'Pays de la Loire',
    url: '/campsites/france/pays-de-la-loire/sarthe/ballon-saint-mars/les-pieds-sur-terre-le-nez-dans-les-haies-la-tete-dans-les-etoiles/',
    rating: 9.8,
    reviewsCount: 34,
    pitchTypes: [
      {
        pitchTypesCount: 6,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 6,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 6,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '8',
    name: 'Champ de la Chapelle',
    region: 'Auvergne',
    url: '/campsites/france/auvergne/allier/montlucon/champ-de-la-chapelle/',
    rating: 9.8,
    reviewsCount: 22,
    pitchTypes: [
      {
        pitchTypesCount: 71,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 71,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 71,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
      {
        pitchTypesCount: 4,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '9',
    name: 'Le Lieu',
    region: 'Aquitaine',
    url: '/campsites/france/aquitaine/dordogne/saint-jory-de-chalais/camping-maisonneuve_/',
    rating: 9.8,
    reviewsCount: 20,
    pitchTypes: [
      {
        pitchTypesCount: 40,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 40,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 40,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 1,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 4,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '10',
    name: 'Chateau du Gandspette',
    region: 'Nord-Pas-de-Calais',
    url: '/campsites/france/nord-pas-de-calais/pas-de-calais/eperlecques/chateau-du-gandspette/',
    rating: 9.7,
    reviewsCount: 133,
    pitchTypes: [
      {
        pitchTypesCount: 70,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 70,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 70,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 15,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '11',
    name: 'Camping La Riviere Doree',
    region: 'Ile-de-France',
    url: '/campsites/france/ile-de-france/seine-et-marne/bagneaux-sur-loing/camping-la-riviere-doree/',
    rating: 9.7,
    reviewsCount: 24,
    pitchTypes: [
      {
        pitchTypesCount: 160,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 160,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 160,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 20,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '12',
    name: 'Camping Saint-Martin',
    region: 'Midi-Pyrénées',
    url: '/campsites/france/midi-pyrenees/aveyron/millau/camping_saint_martin/',
    rating: 9.7,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 50,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 50,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 50,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 1,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 8,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '13',
    name: 'Glamping Sainte-Suzanne',
    region: 'Pays de la Loire',
    url: '/campsites/france/pays-de-la-loire/mayenne/sainte_suzanne/glamping_sainte_suzanne/',
    rating: 9.7,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 13,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 13,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 13,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 13,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '14',
    name: 'Camping Le Bloemstraete',
    region: 'Nord-Pas-de-Calais',
    url: '/campsites/france/nord-pas-de-calais/nord/renescure/camping-le-bloemstraete/',
    rating: 9.6,
    reviewsCount: 106,
    pitchTypes: [
      {
        pitchTypesCount: 30,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 4,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '15',
    name: 'Domaine Le Colombier',
    region: 'Champagne-Ardenne',
    url: '/campsites/france/champagne-ardenne/aube/dienville/camping_le_colombier_/',
    rating: 9.6,
    reviewsCount: 41,
    pitchTypes: [
      {
        pitchTypesCount: 44,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 44,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 44,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 2,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '16',
    name: 'Camping du Bois Fleuri',
    region: 'Centre',
    url: '/campsites/france/centre/eure-et-loir/illiers_combray/camping_du_bois_fleuri/',
    rating: 9.6,
    reviewsCount: 24,
    pitchTypes: [
      {
        pitchTypesCount: 58,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 58,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 58,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 3,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 13,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
      {
        pitchTypesCount: 4,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '17',
    name: 'RCN Domaine de la Noguiere',
    region: "Provence-Alpes-Côte d'Azur",
    url: '/campsites/france/provence-alpes-cote-dazur/var/le-muy/domaine_de_la_noguiere/',
    rating: 9.6,
    reviewsCount: 24,
    pitchTypes: [
      {
        pitchTypesCount: 181,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 181,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 181,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 162,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '18',
    name: 'Camping de la Pointe',
    region: 'Picardie',
    url: '/campsites/france/picardie/aisne/bourg_et_comin/camping_de_la_pointe_/',
    rating: 9.5,
    reviewsCount: 111,
    pitchTypes: [
      {
        pitchTypesCount: 38,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 38,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 38,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 1,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 3,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '19',
    name: 'Camping Le Moulin De Caudon',
    region: 'Aquitaine',
    url: '/campsites/france/aquitaine/dordogne/domme/camping-le-moulin-de-caudon/',
    rating: 9.5,
    reviewsCount: 31,
    pitchTypes: [
      {
        pitchTypesCount: 42,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 42,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 42,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 6,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 14,
        name: 'Caravans for hire',
        slug: 'caravans-for-hire',
        id: '6',
      },
    ],
  },
  {
    id: '20',
    name: 'Les Pilotis du Cognac',
    region: 'Poitou-Charentes',
    url: '/campsites/france/poitou-charentes/charente/bourg_charente/les_pilotis_du_cognac/',
    rating: 9.5,
    reviewsCount: 21,
    pitchTypes: [
      {
        pitchTypesCount: 6,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 6,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 4,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
]

const { $t, $isDesktop } = useNuxtApp()

const title = computed(() => $t('Pitchup.com review awards') as string)

const description = computed(
  () =>
    $t(
      "Pitchup.com's review awards are based on nearly 200,000 customer reviews from 2024. Here's our shortlist of the top rated campsites.",
    ) as string,
)

const head = computed(() => {
  const images = import.meta.glob<{ default: string }>(
    '@/assets/images/review-awards-og-fr.png',
    {
      query: '?url',
      eager: true,
    },
  )
  return {
    title: title.value,
    script: [schemaOrganization.value],
    meta: [
      {
        hid: 'og:title',
        property: 'og:title',
        content: title.value,
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: 'https://www.pitchup.com/review-awards/2024/france/',
      },
      {
        hid: 'description',
        name: 'description',
        property: 'og:description',
        content: description.value,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: images['/assets/images/review-awards-og-fr.png'].default,
      },
      {
        hid: 'og:image:width',
        property: 'og:image:width',
        content: '1200',
      },
      {
        hid: 'og:image:height',
        property: 'og:image:height',
        content: '630',
      },
    ],
  }
})

const schemaOrganization = computed(() => ({
  type: 'application/ld+json',
  body: true,
  json: SCHEMA_ORGANIZATION,
  hid: 'schema-organization',
}))
</script>
<style>
@import url('~/assets/css/review-awards.css');
</style>
